import { createSlice } from "@reduxjs/toolkit";
import { FlatArray } from "../../services/Util";

export const TreeSlice = createSlice({
  name: "tree_structure",

  initialState: {
    treeData: [],
    selectedTreeData: [],
    tabs: [],
    treeValue: {},
  },
  reducers: {
    updateTreeValue: (state, action) => {
      if (action.payload.type) {
        return {
          ...state,
          treeValue: {
            ...state.treeValue,
            [action.payload.type]: action.payload.value,
          },
        };
      } else {
        state.treeValue = action.payload;
      }
    },
    updateTreeData: (state, action) => {
      let localTreeData = JSON.parse(JSON.stringify(action.payload));
      localTreeData?.map((node) => {
        node.level = 0;
        node.targetLanguages = [];
      });
      state.treeData = localTreeData;
    },
    addChildrenToTreeData: (state, action) => {
      let flattenTreeData = FlatArray(state.treeData, "children");
      let localNode = flattenTreeData.find((node) => node.id === action.payload.id);
      if (localNode && !Array.isArray(localNode)) {
        if (localNode?.children === undefined) {
          localNode.children = [];
        }
        if (localNode && localNode.children) {
          localNode.children = action.payload.children;
          localNode.children.map((node) => {
            node.level = localNode.level + 1;
          });
        }
        flattenTreeData.map((node) => {
          if (node.id !== state.treeValue.selectedTreeNode.id && node.level === state.treeValue.selectedTreeNode.level) {
            node.children = [];
          }
        });
      }
    },
    setSelectedTreeData: (state, action) => {
      state.selectedTreeData = action.payload;
    },
    addToSelectedTreeData: (state, action) => {
      let index = state.selectedTreeData.findIndex((data) => data.id === action.payload.id);
      state.selectedTreeData = state.selectedTreeData.filter((data) => data.id !== action.payload.id);
      if (state.selectedTreeData.filter((data) => data.id === action.payload.id).length === 0) {
        state.selectedTreeData?.splice(index, 0, action.payload);
      }
      let flattenTreeData = FlatArray(state.treeData, "children");
      flattenTreeData?.map((node) => {
        if (node.id === action.payload.id) {
          node.checked = true;
          if (node.children?.length > 0) {
            let flattenChildData = FlatArray(node.children, "children");
            flattenChildData?.map((data) => {
              data.checked = true;
              data.disabled = true;
            });
          }
        }
      });
    },
    removeFromSelectedTreeData: (state, action) => {
      state.selectedTreeData = state.selectedTreeData.filter((data) => data && data.id !== action.payload.id);

      let flattenTreeData = FlatArray(state.treeData, "children");
      flattenTreeData.map((node) => {
        if (node.id === action.payload.id) {
          node.checked = false;
          if (node.children?.length > 0) {
            let flattenChildData = FlatArray(node.children, "children");
            flattenChildData?.map((data) => {
              data.checked = false;
              data.disabled = false;
            });
          }
        }
      });
    },
    updateTab: (state, action) => {
      state.tabs = action.payload;
    },
    getSelectedTab: (state) => {
      return state.tabs.filter((tab) => tab.isActive);
    },
    setTreeLoading: (state, action) => {
      state.treeValue.isTreeLoading = action.payload;
    },
    setDisplayName: (state, action) => {
      state.treeValue.displayName = action.payload;
    },
    setContentType: (state, action) => {
      state.treeValue.contentType = action.payload;
    },
    updateCredentialsSet: (state, action) => {
      state.treeValue.credentialsSet = action.payload;
    },
    updateWidthChanges: (state, action) => {
      state.treeValue.widthChanges = action.payload;
    },
    updateSearchText: (state, action) => {
      state.treeValue.searchText = action.payload;
      let tab = state.tabs.find((tab) => tab.isActive);
      tab.searchText = action.payload;
    },
    updateSelectedTreeNode: (state, action) => {
      let flattenTreeData = FlatArray(state.treeData, "children");
      flattenTreeData.map((node) => {
        if (action?.payload !== null) {
          if (node.id === action.payload.id) {
            node.selected = true;
          } else if (node.level === action.payload.level) {
            node.selected = false;
          }
        }
      });

      var localNode = JSON.parse(JSON.stringify(action.payload));
      if (localNode !== null) {
        localNode.selected = true;
      }
      state.treeValue.selectedTreeNode = localNode;
    },
    updateSelectedTreeDataTargetLang: (state, action) => {
      state.selectedTreeData.map((data) => {
        if (data.targetLanguages === undefined) {
          data.targetLanguages = [];
        }
      });
      let index = action.payload.index;
      if (index > -1) {
        let targetLangs = state?.selectedTreeData[index]?.targetLanguages?.filter((lang) => lang?.language !== action?.payload?.language?.language || lang.display !== action.payload.language.display);
        targetLangs.push(action.payload.language);
        state.selectedTreeData[index].targetLanguages = targetLangs;
      } else {
        state.selectedTreeData.map((data) => {
          let targetLangs = data.targetLanguages.filter((lang) => (lang.language !== action.payload.language.language || lang.display !== action.payload.language.display));
          targetLangs.push(action.payload.language);
          data.targetLanguages = targetLangs;
        });
      }
    },
    removeSelectedTreeDataTargetLang: (state, action) => {
      let index = action.payload.index;
      let langIndex = action.payload.langIndex;
      let language = action.payload.language;
      state?.selectedTreeData[index]?.targetLanguages?.splice(langIndex, 1);
    },
    resetTree: (state) => {
      state.treeData = [];
      state.selectedTreeData = [];
      state.tabs = [];
      state.treeValue = {};
    },
  },
});

export const {
  updateTreeValue,
  updateTreeData,
  addChildrenToTreeData,
  setSelectedTreeData,
  addToSelectedTreeData,
  removeFromSelectedTreeData,
  updateTab,
  setTreeLoading,
  setDisplayName,
  setContentType,
  updateCredentialsSet,
  resetTree,
  updateSearchText,
  updateSelectedTreeNode,
  updateSelectedTreeDataTargetLang,
  removeSelectedTreeDataTargetLang,
  updateWidthChanges
} = TreeSlice.actions;

export default TreeSlice.reducer;
